import '@/assets/scss/style.scss';

import { QueryClientProvider } from '@tanstack/react-query';
import {
    App as AntdApp, ConfigProvider, theme as AntdTheme,
} from 'antd';
import locale from 'antd/locale/uk_UA';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/router';
import {
    darkTheme, lightTheme,
} from '@/themes';
import { queryClient } from '@/utils';

import { Loader } from './components';
import { useNotification } from './hooks';
import { useUIStore } from './stores';

const App = () => {
    const { theme } = useUIStore();
    const { contextHolder } = useNotification();

    const themeSettings = useMemo(() => {
        if (theme === 'light') {
            return {
                algorithm: AntdTheme.defaultAlgorithm,
                ...lightTheme,
            };
        }

        return {
            algorithm: AntdTheme.darkAlgorithm,
            ...darkTheme,
        };
    }, [theme]);

    return (
        <ConfigProvider theme={themeSettings} locale={locale}>
            <QueryClientProvider client={queryClient}>
                <NuqsAdapter>
                    <AntdApp className={`color-scheme-${theme}`}>
                        <RouterProvider router={router} fallbackElement={<Loader />} />
                        {contextHolder}
                    </AntdApp>
                </NuqsAdapter>
            </QueryClientProvider>
        </ConfigProvider>
    );
};

const rootElement = document.getElementById('app');
const root = createRoot(rootElement as HTMLElement);
root.render(<App />);
